export enum PictureLoading {
  LAZY = 'lazy',
  EAGER = 'eager',
}

export enum ObjectFit {
  CONTAIN = 'contain',
  COVER = 'cover',
}
